var _g, _g2, _title;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutterSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "file_type_flutter")), /*#__PURE__*/React.createElement("polyline", {
    points: "15.383 18.316 18.744 15.042 27.093 15.042 19.697 22.438 15.383 18.316 15.383 18.316 15.383 18.316 15.383 18.316 15.383 18.316",
    style: {
      fill: "#40d0fd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.907 16.125 9.106 20.424 27.093 2.287 18.744 2.287 4.907 16.125",
    style: {
      fill: "#41d0fd",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.176 22.479 15.435 26.675 19.697 22.438 15.383 18.316 11.176 22.479",
    style: {
      fill: "#1fbcfd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.435 26.675 19.697 22.438 26.989 29.813 18.593 29.813 15.435 26.675",
    style: {
      fill: "#095a9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.435 26.675 19.406 25.354 18.068 24.057 15.435 26.675",
    style: {
      fill: "#0e5199"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterSvgrepoCom);
export default __webpack_public_path__ + "static/media/flutter-svgrepo-com.3b63d9aa092fcb8f93525327c90a1258.svg";
export { ForwardRef as ReactComponent };